import {useLocation} from "react-router-dom";
import hosakshamOnlyLogo from "../../../../../assets/HosakshamOnlyLogo.png"
import CryptoJS, {AES} from 'crypto-js';
import {useEffect, useState} from "react";

import axios from 'axios';
import {load} from '@cashfreepayments/cashfree-js';
import {CircularProgress, Typography} from '@mui/material';
import {SECRETS_ENV} from "../../../../../Config/firebase";
import * as React from "react";


// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-expect-error
const CRYPTO_SECRET = import.meta.env.VITE_CRYPTO_SECRET || process.env.VITE_CRYPTO_SECRET
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-expect-error
const FLAVOR = import.meta.env.VITE_FLAVOR || process.env.VITE_FLAVOR;

export default function CashfreePayments() {

    // Function to decrypt the data
    const decryptData = (encryptedData: string, secretKey: string) => {
        const bytes = AES.decrypt(encryptedData, secretKey);
        return JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
    };

    // Component States
    const location = useLocation();
    const [paymentData, setPaymentData] = useState<any>(null);
    const [cashfree, setCashfree] = useState<any>(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);
    const [amount, setAmount] = useState<number>(100);
    const [promoCode, setPromoCode] = useState<string>('');
    const [discount, setDiscount] = useState<number>(0);
    const [isEditable, setIsEditable] = useState<boolean>(false);
    const [isCreditPurchase, setIsCreditPurchase] = useState<boolean>(false);
    const [isSubscription, setIsSubscription] = useState<boolean>(false);
    const [tax, setTax] = useState<number>(0)

    const API_ENDPOINT = SECRETS_ENV.API_END_POINT;
    const URL = `${API_ENDPOINT}/api/cashfreePayment`;

    // Function to setup Payment Status
    useEffect(() => {
        const searchParams = new URLSearchParams(location.search);
        const encryptedData = searchParams.get('data');
        if (encryptedData) {
            const decodedData = decodeURIComponent(encryptedData);

            try {
                const decryptedData = decryptData(decodedData, CRYPTO_SECRET);
                setPaymentData(decryptedData);
            } catch (error) {
                console.error('Error decrypting data:', error);
                throw error
            }

        }
    }, [location]);

    // Cashfree SDK Initialisation

    useEffect(() => {
        const initializeSDK = async () => {
            try {
                const sdk = await load({mode: 'production'});
                setCashfree(sdk);
            } catch (err) {
                console.error('Error initializing Cashfree SDK:', err);
                setError('Failed to initialize payment system. Please try again later.');
            }
        };

        initializeSDK();
    }, []);

    useEffect(() => {
        if (paymentData) {
            setAmount(paymentData.amount);
            setIsEditable(paymentData.isEditable ?? false);
            setIsCreditPurchase(paymentData.isCreditPurchase ?? false);
            setIsSubscription(paymentData.isSubscription ?? false);

            const calculatedTax = (paymentData.amount * 0.18).toFixed(2);
            setTax(Number(calculatedTax))

        }
    }, [paymentData]);

    useEffect(()=>{
        if(amount){

        
        const calculatedTax = (amount * 0.18).toFixed(2);
        setTax(Number(calculatedTax))
    }},[amount])

    // Hnadle Change Functions

    const handleDecrementAmount = () => {
        if (isEditable) {
            setAmount(prevAmount => Math.max(100, prevAmount - 50));
        }
    };

    const handleIncrementAmount = () => {
        if (isEditable) {
            setAmount(prevAmount => prevAmount + 50);
        }
    };

    const handleAddAmount = (value: number) => {
        if (isEditable) {
            setAmount(prevAmount => prevAmount + value);
        }
    };


    const getSessionId = async () => {

        try {
            const paymentDatas = {

                order_amount: FLAVOR==="DEVELOPMENT"?2.36:amount+tax,

                order_currency: "INR",
                customer_details: {
                    customer_id: paymentData.customerDetails.customerId,
                    customer_email: paymentData.customerDetails.customerEmail,
                    customer_phone: paymentData.customerDetails.customerPhone,
                    customer_name: paymentData.customerDetails.customerName
                },
                order_meta: {
                    notify_url:`${API_ENDPOINT}/api/cashFreePaymentProcessingWebhookHandler`
                },
                order_note: `Payment for Purchase of ${paymentData.planType} plan`,
                order_tags: {
                    planType: paymentData.planType,
                    planId: paymentData.planId,
                    isCreditPurchase: String(isCreditPurchase),
                    isSubscription: String(isSubscription),

                    tax: FLAVOR === "DEVELOPMENT" ? String(0.36) : String(tax)

                },
                providerId: paymentData.providerId,
                isCreditPurchase: isCreditPurchase,
                isSubscription: isSubscription,
                planId: paymentData.planId,
                message: isCreditPurchase
                    ? `Credit purchase of ${FLAVOR==="DEVELOPMENT"?1:Math.round(amount/2)} credits`
                    : `Subscription payment for ${paymentData.planType} plan`,
            };


            const res = await axios.post(`${URL}/initiate`, paymentDatas);

            if (res.data && res.data.payment_session_id) {

                return {
                    sessionId: res.data.payment_session_id,
                    orderId: res.data.order_id
                };
            } else {
                throw new Error('Invalid response from payment server');
            }
        } catch (error) {
            console.error('Error getting session ID:', error);
            throw error;
        }
    };

    const handlePaymentClick = async (e: React.MouseEvent) => {
        e.preventDefault();
        setLoading(true);
        setError(null);


        try {
            const sessionData = await getSessionId();


            if (cashfree && sessionData.sessionId) {
                const checkoutOptions = {
                    paymentSessionId: sessionData.sessionId,
                    returnUrl: `${window.location.origin}/paymentResult?order_id={order_id}`,
                    redirectTarget: '_top',
                };


                await cashfree.checkout(checkoutOptions);
                // The page will redirect
            } else {
                throw new Error('Failed to initialize payment');
            }
        } catch (error) {
            console.error('Error initiating payment:', error);
            setError('Failed to initiate payment. Please try again.');
        } finally {
            setLoading(false);
        }
    };

    if (!paymentData) {
        return <Typography>Invalid payment data. Please go back and try again.</Typography>;
    }

    return (
        <div>
            <div
                className="fixed inset-0 z-[80] overflow-y-auto bg-gray-400 bg-opacity-50 flex items-center justify-center">
                <div className="bg-white shadow-lg rounded-xl w-full max-w-lg m-2 max-h-[95vh] ">
                    <div className="relative overflow-hidden min-h-32 bg-cc_brand text-center rounded-t-xl">

                        <figure className="absolute inset-x-0 bottom-0 -mb-px">
                            <svg preserveAspectRatio="none" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px"
                                 viewBox="0 0 1920 100.1">
                                <path fill="currentColor" className="fill-white"
                                      d="M0,0c0,0,934.4,93.4,1920,0v100.1H0L0,0z"></path>
                            </svg>
                        </figure>

                    </div>

                    <div className="relative z-10 -mt-12">

            <span
                className="mx-auto flex justify-center items-center size-[62px] overflow-hidden rounded-full border p-1 border-gray-200 bg-white text-gray-700 shadow-sm">
              <img src={hosakshamOnlyLogo} className="" alt="Ho"/>
            </span>

                    </div>


                    <div className="p-6 diff-scrollbar overflow-y-auto max-h-[calc(95vh-160px)]">
                        <div className="text-center mb-4">
                            <h3 id="hs-ai-modal-label" className="text-xl font-semibold text-gray-800">
                                Payment for : Hosaksham
                            </h3>
                            <p className="mt-2 text-sm text-gray-600">Plan : Custom Credits</p>
                        </div>

                        {paymentData.customerDetails && <div className="mb-4 bg-gray-100 rounded-lg pl-4 py-2">
                            <h4 className="text-sm font-semibold text-gray-700 mb-2">Customer Details</h4>
                            <p className="text-sm text-gray-600">Name : {paymentData.customerDetails.customerName}</p>
                            <p className="text-sm text-gray-600 mt-1">Phone : {paymentData.customerDetails.customerPhone} </p>
                            <p className="text-sm text-gray-600 mt-1">Email : {paymentData.customerDetails.customerEmail} </p>
                        </div>}

                        <div className="mb-6">
                            <label htmlFor="payment-amount" className="block text-sm font-medium text-gray-700 mb-4">
                                Payment Amount (₹)
                            </label>
                            <div className="flex items-center justify-center space-x-4 mb-4">
                                <button onClick={() => {
                                    handleDecrementAmount()
                                }} className="p-2 rounded-full bg-blue-100 text-blue-600 hover:bg-blue-200">
                                    <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none"
                                         viewBox="0 0 24 24" stroke="currentColor">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2}
                                              d="M20 12H4"/>
                                    </svg>
                                </button>
                                <input
                                    id="payment-amount"
                                    type="text"
                                    className="w-24 text-center border-gray-300 rounded-md shadow-sm focus:border-blue-300 focus:ring focus:ring-blue-200 focus:ring-opacity-50"
                                    value={amount}
                                    readOnly
                                />
                                <button onClick={() => {
                                    handleIncrementAmount()
                                }} className="p-2 rounded-full bg-blue-100 text-blue-600 hover:bg-blue-200">
                                    <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none"
                                         viewBox="0 0 24 24" stroke="currentColor">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2}
                                              d="M12 6v6m0 0v6m0-6h6m-6 0H6"/>
                                    </svg>
                                </button>
                            </div>
                            <div className="flex justify-center space-x-4 mb-4">
                                <button onClick={() => {
                                    handleAddAmount(20)
                                }} className="px-4 py-2 bg-blue-50 text-blue-600 rounded-full hover:bg-blue-100">+₹20
                                </button>
                                <button onClick={() => {
                                    handleAddAmount(50)
                                }} className="px-4 py-2 bg-blue-50 text-blue-600 rounded-full hover:bg-blue-100">+₹50
                                </button>
                                <button onClick={() => {
                                    handleAddAmount(100)
                                }} className="px-4 py-2 bg-blue-50 text-blue-600 rounded-full hover:bg-blue-100">+₹100
                                </button>
                            </div>
                            <p className="text-center text-sm text-gray-600">
                                You Will Receive <span
                                className="font-semibold text-blue-600">{Math.round(amount / 2)} HoSaksham credit</span> for <span
                                className="font-semibold text-blue-600"> ₹{amount} </span>
                            </p>
                        </div>

                        <div className="mb-6">
                            <h4 className="text-sm font-semibold text-gray-800 mb-3">Payment Summary</h4>
                            <ul className="space-y-2">
                                <li className="flex justify-between text-sm">
                                    <span className="text-gray-600">Amount</span>
                                    <span className="font-medium">₹{amount}</span>
                                </li>
                                <li className="flex justify-between text-sm">

                                    <span className="text-gray-600">GST (18%)</span>
                                    <span className="font-medium">₹{tax}</span>
                                </li>
                                <li className="flex justify-between text-sm font-semibold">
                                    <span>Total</span>
                                    <span>₹{(amount +tax)}</span>

                                </li>
                            </ul>
                        </div>

                        <div className="mt-8 flex justify-end">

                            <button
                                onClick={handlePaymentClick} disabled={loading}
                                className={`w-full bg-cc_brand text-white p-1.5 rounded-lg border-gray-500 flex justify-center items-center ${loading ? "cursor-not-allowed" : "cursor-pointer"}`}>{loading &&
                                <CircularProgress sx={{color: "white"}} size={20}/>}
                                <p className={"ml-2"}>{loading ? "Loading" : "Proceed to Payment"}</p>
                            </button>
                        </div>

                        <div className="mt-5 sm:mt-10">
                            <p className="text-sm text-gray-500">If you have any questions, please contact us at <a
                                className="inline-flex items-center gap-x-1.5 text-blue-600 decoration-2 hover:underline focus:outline-none focus:underline font-medium"
                                href="#">support@hosaksham.com</a> or call at <a
                                className="inline-flex items-center gap-x-1.5 text-blue-600 decoration-2 hover:underline focus:outline-none focus:underline font-medium"
                                href="tel:+916363860121">+91 63638 60121</a></p>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    )
}